import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { SimplePageHeader, StatusHandler } from '../../components'
import { fetchIndividu } from '../../features/individu/slice'
import { DefaultLayout } from '../../layouts'
import { MainContent, ProfileHeader } from './components'

let lastId = null

const Profile = ({ match }) => {
  const dispatch = useDispatch()
  const id = match.params.id
  const individu = useSelector(state => state.individu.profile_page_data)
  const status = useSelector(state => state.individu.status)
  const error = useSelector(state => state.individu.error)

  const fetchData = React.useCallback(() => {
    if(status === 'idle' && id){
      lastId = id
      dispatch(fetchIndividu(id))
    } else {
      if(id !== lastId){
        lastId = id
        dispatch(fetchIndividu(id))
      }
    }
  }, [dispatch, status, id])

  React.useEffect(() => {
    fetchData()
    //eslint-disable-next-line
  }, [])

  return (
    <DefaultLayout>
      <SimplePageHeader noPadding/>
      <StatusHandler
        status={status}
        error={error}
        onRetry={() => fetchData()}
      >
        <ProfileHeader profile={individu}/>
        <MainContent profile={individu}/>
      </StatusHandler>
    </DefaultLayout>
  )
}

export { Profile }
